import { app } from '../../app.module'
app
  // アカウントテーブルページネーション
  .directive('accountTablePagination', () => {
    return {
      restrict: 'E',
      template: require('./account-table-pagination.pug')(),
    }
  })
